module.exports = __webpack_public_path__ + "img/TEL.d57f263d.svg";